import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

import { Link } from "@/components/clickable";
import { cx } from "@/utils";

export default function AlertBanner({ text, link, className }) {
  return (
    <div
      className={cx(
        "rounded-lg border border-yellow-400 bg-yellow-50 p-4",
        className,
      )}
    >
      <div className="flex">
        <div className="shrink-0">
          <ExclamationTriangleIcon
            aria-hidden="true"
            className="size-5 fill-yellow-500"
          />
        </div>
        <div className="ml-3">
          <p className="text-sm">
            {text}{" "}
            {link && (
              <Link
                href={link.href}
                className="font-medium text-yellow-700 underline hover:text-yellow-600"
              >
                {link.text}
              </Link>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
